import request from './request'

export function getOverviewPermission() {
  return request({
    url: '/market/overviewPermission',
    method: 'get'
  })
}
export function getRetainPermission() {
  return request({
    url: '/market/retainPermission',
    method: 'get'
  })
}

export function getPaymentPermission() {
  return request({
    url: '/market/paymentPermission',
    method: 'get'
  })
}

export function getOverviewList(data) {
  return request({
    url: '/market/getOverviewList',
    method: 'post',
    data
  })
}
export function getOverviewWithHourList(data) {
  return request({
    url: '/market/getOverviewWithHourList',
    method: 'post',
    data
  })
}
export function getRetainList(data) {
  return request({
    url: '/market/getRetainList',
    method: 'post',
    data
  })
}

export function getPaymentList(data) {
  return request({
    url: '/market/getPaymentList',
    method: 'post',
    data
  })
}

export function getHourOverviewPermission() {
  return request({
    url: '/market/hourOverviewPermission',
    method: 'get'
  })
}

export function getSimpleOverviewWithHourList(data) {
  return request({
    url: '/market/getSimpleOverviewWithHourList',
    method: 'post',
    data
  })
}

export function getSimpleHourOverviewPermission() {
  return request({
    url: '/market/simpleHourOverviewPermission',
    method: 'get'
  })
}

export function getFlowEstimateList(data) {
  return request({
    url: '/market/getFlowEstimateList',
    method: 'post',
    data
  })
}

export function getFlowEstimatePermission(data) {
  return request({
    url: '/market/getFlowEstimatePermission',
    method: 'post',
    data
  })
}

export function getFlowEstimateConfig(data) {
  return request({
    url: '/market/getFlowEstimateConfig',
    method: 'post',
    data
  })
}

export function editFlowEstimateConfig(data) {
  return request({
    url: '/market/editFlowEstimateConfig',
    method: 'post',
    data
  })
}

export function recoveryFlowEstimateConfig(data) {
  return request({
    url: '/market/recoveryFlowEstimateConfig',
    method: 'post',
    data
  })
}

export function getRechargeRankPermission() {
  return request({
    url: '/market/rechargeRankPermission',
    method: 'get'
  })
}

export function getRechargeRankList(data) {
  return request({
    url: '/market/getRechargeRankList',
    method: 'post',
    data
  })
}

export function getRechargeRankCount(data) {
  return request({
    url: '/market/getRechargeRankCount',
    method: 'post',
    data
  })
}

export function getAbnormalAgentMsg(data) {
  return request({
    url: '/gameWarning/getAbnormalAgentMsg',
    method: 'post',
    data
  })
}

export function addConfig(data) {
  return request({
    url: '/teamConfig/addConfig',
    method: 'post',
    data
  })
}

export function editConfig(data) {
  return request({
    url: '/teamConfig/editConfig',
    method: 'post',
    data
  })
}

export function getConfigList(data) {
  return request({
    url: '/teamConfig/getConfigList',
    method: 'post',
    data
  })
}

export function getTeamConfigDataList(data) {
  return request({
    url: '/teamConfig/getTeamConfigDataList',
    method: 'post',
    data
  })
}

export function refreshTeamConfig(data) {
  return request({
    url: '/teamConfig/refresh',
    method: 'post',
    data
  })
}

export function deleteConfig(data) {
  return request({
    url: '/teamConfig/deleteConfig',
    method: 'post',
    data
  })
}

export function getAllFilter(data) {
  return request({
    url: '/teamConfig/getAllFilter',
    method: 'post',
    data
  })
}

export function getTargetAndDimension(data) {
  return request({
    url: '/teamConfig/getTargetAndDimension ',
    method: 'post',
    data
  })
}

export function getMultipleConfigList(data) {
  return request({
    url: '/teamDataGrowthFactor/getConfigList',
    method: 'post',
    data
  })
}

export function addMultipleConfig(data) {
  return request({
    url: '/teamDataGrowthFactor/addConfig',
    method: 'post',
    data
  })
}

export function editMultipleConfig(data) {
  return request({
    url: '/teamDataGrowthFactor/editConfig',
    method: 'post',
    data
  })
}

export function deleteMultipleConfig(data) {
  return request({
    url: '/teamDataGrowthFactor/deleteConfig',
    method: 'post',
    data
  })
}

export function teamGrowthFactorPermission(data) {
  return request({
    url: '/teamDataGrowthFactor/teamGrowthFactorPermission',
    method: 'post',
    data
  })
}

export function getPaymentMonthPermission(data) {
  return request({
    url: '/market/getPaymentMonthPermission ',
    method: 'post',
    data
  })
}

export function getPaymentMonthList(data) {
  return request({
    url: '/market/getPaymentMonthList ',
    method: 'post',
    data
  })
}

export function getExceptionList(data) {
  return request({
    url: '/market/getExceptionList ',
    method: 'post',
    data
  })
}

export function exceptionDetail(data) {
  return request({
    url: '/market/exceptionDetail',
    method: 'post',
    data
  })
}

export function getActionRetainList(data) {
  return request({
    url: '/market/getActionRetainList',
    method: 'post',
    data
  })
}

export function getActionRetainPermission(data) {
  return request({
    url: '/market/actionRetainPermission',
    method: 'post',
    data
  })
}

export function addCustomTarget(data) {
  return request({
    url: '/customizedTarget/addTarget',
    method: 'post',
    data
  })
}

export function updateCustomTarget(data) {
  return request({
    url: '/customizedTarget/updateTarget',
    method: 'post',
    data
  })
}

export function batchUpdateCustomTarget(data) {
  return request({
    url: '/customizedTarget/batchUpdateTarget',
    method: 'post',
    data
  })
}

export function deleteCustomTarget(data) {
  return request({
    url: '/customizedTarget/delTarget',
    method: 'post',
    data
  })
}

export function getOverviewRecentQueries(data) {
  return request({
    url: '/market/getOverviewRecentQueries',
    method: 'post',
    data
  })
}

